import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { IContractManagement } from '../IContractManagement';
import * as ContractManagementActions from './contract-management.actions';

export const contractManagementsFeatureKey = 'contractManagements';

export interface State extends EntityState<IContractManagement> {
    // additional entities state properties
}

export const adapter: EntityAdapter<IContractManagement> =
    createEntityAdapter<IContractManagement>({
        selectId: (model: IContractManagement) => model.ContractListID
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const contractManagementReducer = createReducer(
    initialState,
    on(ContractManagementActions.addContractManagement, (state, action) =>
        adapter.addOne(action.contractManagement, state)
    ),
    on(ContractManagementActions.upsertContractManagement, (state, action) =>
        adapter.upsertOne(action.contractManagement, state)
    ),
    on(ContractManagementActions.addContractManagements, (state, action) =>
        adapter.addMany(action.contractManagements, state)
    ),
    on(ContractManagementActions.upsertContractManagements, (state, action) =>
        adapter.upsertMany(action.contractManagements, state)
    ),
    on(ContractManagementActions.updateContractManagement, (state, action) =>
        adapter.updateOne(action.contractManagement, state)
    ),
    on(ContractManagementActions.updateContractManagements, (state, action) =>
        adapter.updateMany(action.contractManagements, state)
    ),
    on(ContractManagementActions.deleteContractManagement, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(ContractManagementActions.deleteContractManagements, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(ContractManagementActions.loadContractManagements, (state, action) =>
        adapter.setAll(action.contractManagements, state)
    ),
    on(ContractManagementActions.clearContractManagements, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return contractManagementReducer(state, action);
}

export const selectContractMgmtState = createFeatureSelector<State>(
    contractManagementsFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectContractMgmtState);
